import { create } from "zustand";
import { wallets as seed } from "@/mocks/seed";
import type { Wallet } from "@/types";

/** Mock store for wallets when unauthenticated / API down (Phase 5.2).
 *  Wallet balances are server rollups; the only sanctioned mutation is top-up
 *  (mirrors the API, which has no wallet create/delete). Archive is a mock-only
 *  nicety since the backend defers wallet archive/restore. */
interface WalletsState {
  active: Wallet[];
  archived: Wallet[];
  topup: (id: string, amountUsd: number, rate: number) => void;
  archive: (id: string) => void;
}

export const useWalletsStore = create<WalletsState>((set) => ({
  active: seed,
  archived: [],
  topup: (id, amountUsd, rate) =>
    set((s) => ({
      active: s.active.map((w) =>
        w.id === id
          ? { ...w, balanceUsd: w.balanceUsd + amountUsd, fundedDzd: w.fundedDzd + Math.round(amountUsd * rate) }
          : w,
      ),
    })),
  archive: (id) =>
    set((s) => {
      const target = s.active.find((w) => w.id === id);
      if (!target) return s;
      return { active: s.active.filter((w) => w.id !== id), archived: [target, ...s.archived] };
    }),
}));
